import { Box, Flex, Space } from '@mantine/core';
import { useParams } from '@tanstack/react-router';

import { ClubInteractionContainer } from '@/features/work-interactions/containers/ClubInteractionContainer';
import { translate } from '@/shared/i18n/translate';
import { LBBackButton } from '@/shared/modules';
import { LBLinkButton } from '@/shared/ui-kit/components';

import { useArtistCurrentContractQuery } from '../../api';
import { NotFoundCurrentWork } from '../../components/not-found-current-work/NotFoundCurrentWork';

export const CurrentWorkPage = () => {
  const { id: artistId } = useParams({ from: '/artist/$id/current-work' });
  const currentContract = useArtistCurrentContractQuery({
    profileId: artistId
  });
  return (
    <Box>
      <Flex align='center' justify='space-between'>
        <LBBackButton />
        <LBLinkButton>{translate('commons.help')}</LBLinkButton>
      </Flex>
      <Space h={16} />
      {currentContract.data?.data ? (
        <ClubInteractionContainer
          artistId={artistId}
          workItemId={currentContract.data.data.workItemId.toString()}
        />
      ) : (
        <NotFoundCurrentWork />
      )}
    </Box>
  );
};
